import { css } from 'styled-components';
import { CFMixins } from '../../mixins';
import { CFTokens } from '../../tokens';
import { CFBaseFormFieldHelpers, CFBaseFormFieldTokens } from './styles';
export const CFBaseFormFieldStyles = {
    Caption: css `
    color: ${CFBaseFormFieldHelpers.captionColor};
    ${CFMixins.typeSpec(CFBaseFormFieldTokens.TYPE_SPEC.CAPTION)};
  `,
    CaptionContainer: css `
    width: 100%;
    display: flex;
    flex-direction: row;
    gap: ${CFTokens.SPACER.D}px;
  `,
    CaptionMain: css `
    flex: 1;
  `,
    ControlWrapper: css `
    width: 100%;
    display: flex;
    gap: ${CFTokens.SPACER.D}px;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
  `,
    ErrorContainer: css `
    display: flex;
    flex-direction: column;
    gap: ${CFTokens.SPACER.B}px;
  `,
    Label: css `
    color: ${CFBaseFormFieldTokens.LABEL_COLOR};
    ${CFMixins.typeSpec(CFBaseFormFieldTokens.TYPE_SPEC.LABEL)};
  `,
    Root: css `
    width: 100%;
    display: flex;
    gap: ${CFTokens.SPACER.B}px;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    position: relative;
    z-index: ${CFBaseFormFieldHelpers.rootZIndex};
  `,
};
